import { useState, useRef, useEffect } from 'react'
import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import Image from 'components/Image'
import { withTranslation } from 'server/i18n'
import { Box } from 'reflexbox'
import Modal from 'components/Modal'
import dynamic from 'next/dynamic'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

import layoutTheme from 'theme/layout-theme'

import style from './BoatMainImage.style'

const PhotoGallerySlider = dynamic(
    () => import(/* webpackChunkName: 'PhotoGallerySlider' */ 'components/PhotoGallerySlider'),
    {
        ssr: false
    }
)

const BoatMainImageStyled = styled.div(props => ({ ...style(props) }))

const BoatMainImage = ({ t, image, mobileImage, noAboveTheFold, hasGallery, galleryImages }) => {
    const [imageHeight, setImageHeight] = useState(null)
    const [modalOpen, setModalOpen] = useState(false)

    const imageContainer = useRef()

    /* if (modalOpen) {
        disableBodyScroll()
    } else {
        enableBodyScroll()
    } */

    useEffect(() => {
        if (process.browser && !noAboveTheFold) {
            setTimeout(() => {
                if (imageContainer.current) {
                    const imageContainerTop =
                        imageContainer.current.getBoundingClientRect().top + document.documentElement.scrollTop
                    setImageHeight(window.innerHeight - imageContainerTop - 20)
                }
            }, 100)
        }
    }, [])

    return (
        <BoatMainImageStyled ref={imageContainer} imageHeight={imageHeight} mobileImage={mobileImage}>
            {!mobileImage && <Image src={image} className="absoluteImage" onClick={() => {}} />}

            {mobileImage && (
                <>
                    <Box theme={layoutTheme} display={['block', null, 'none']}>
                        <Image
                            src={mobileImage}
                            onClick={() => {
                                if (hasGallery) {
                                    setModalOpen(true)
                                }
                                {
                                    modalOpen && (
                                        <Modal close={() => setModalOpen(false)} bodyScroll={false} hasAnotherModal>
                                            {process.browser && (
                                                <PhotoGallerySlider images={galleryImages} gtmPDPExterior />
                                            )}
                                        </Modal>
                                    )
                                }
                            }}
                        />
                    </Box>
                    <Box theme={layoutTheme} display={['none', null, 'block']}>
                        <Image
                            src={image}
                            className="absoluteImage"
                            onClick={() => {
                                if (hasGallery) {
                                    setModalOpen(true)
                                }
                                {
                                    modalOpen && (
                                        <Modal close={() => setModalOpen(false)} bodyScroll={false} hasAnotherModal>
                                            {process.browser && (
                                                <PhotoGallerySlider images={galleryImages} gtmPDPExterior />
                                            )}
                                        </Modal>
                                    )
                                }
                            }}
                        />
                    </Box>
                </>
            )}

            {hasGallery && (
                <>
                    <button className="viewGallery" type="button" onClick={() => setModalOpen(true)}>
                        {t('view-gallery')}
                    </button>

                    {modalOpen && (
                        <Modal close={() => setModalOpen(false)} bodyScroll={false} hasAnotherModal>
                            {process.browser && <PhotoGallerySlider images={galleryImages} gtmPDPExterior />}
                        </Modal>
                    )}
                </>
            )}
        </BoatMainImageStyled>
    )
}

BoatMainImage.propTypes = {
    t: PropTypes.func.isRequired,
    image: PropTypes.string.isRequired,
    mobileImage: PropTypes.string,
    noAboveTheFold: PropTypes.bool,
    hasGallery: PropTypes.bool,
    galleryImages: PropTypes.arrayOf(
        PropTypes.shape({
            url: PropTypes.string.isRequired,
            name: PropTypes.string,
            specification: PropTypes.string,
            price: PropTypes.string
        })
    )
}

BoatMainImage.defaultProps = {
    noAboveTheFold: false,
    hasGallery: false,
    mobileImage: null,
    galleryImages: null
}

export default withTranslation('common')(withTheme(BoatMainImage))
